import {cx} from '@emotion/css';
import React, {ReactElement} from 'react';

import styles from './Vimeo.styles';

const COLOR = 'fcc22d';

export interface Props {
  title?: string;
  url: string;
  displayVideoInfo?: boolean;
  // vimeo controls
  autoplay?: boolean;
  controls?: boolean;
  muted?: boolean;
}

function Vimeo({
  autoplay = false,
  controls = true,
  muted = false,
  title,
  url,
  displayVideoInfo = false,
}: Props): ReactElement {
  const videoInfoParams = displayVideoInfo ? '' : '&portrait=false&title=false&byline=false';
  const urlWithParams = `${url}?color=${COLOR}&autoplay=${autoplay}&controls=${controls}&muted=${muted}&responsive=true${videoInfoParams}`;

  return (
    <div className={cx(styles.vimeo)}>
      <iframe
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
        frameBorder="0"
        src={urlWithParams}
        title={title}
      />
    </div>
  );
}

export default Vimeo;
